<template>
  <div class="home-page">
    <!-- Hero Section -->
    <section class="hero-section">
      <div id="heroCarousel" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner">
          <div
            v-for="(slide, index) in heroSlides"
            :key="index"
            :class="['carousel-item', { active: index === 0 }]">
            <div class="hero-slide" :style="{ backgroundImage: `url(${slide.image})` }">
              <div class="overlay"></div>
              <!-- <div class="container">
                <div class="row">
                  <div class="col-lg-6 offset-lg-6">
                    <div class="hi-text">
                      <span>{{ slide.subtitle }}</span>
                      <h1>
                        Be <strong>{{ slide.strongText }}</strong> {{ slide.title }}
                      </h1>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </section>

    <!-- Features Section -->
    <section class="features-section py-5">
      <div class="container">
        <div class="text-center mb-5">
          <span class="section-subtitle">Why Choose Us?</span>
          <h2 class="section-title">Push Your Limits Forward</h2>
        </div>
        <div class="row">
          <div
            v-for="(feature, index) in features"
            :key="index"
            class="col-lg-3 col-sm-6 text-center">
            <div class="feature-item">
              <font-awesome-icon :icon="['fas', feature.icon]" class="feature-icon" size="3x"  />
              <h4 class="mt-3">{{ feature.title }}</h4>
              <p>{{ feature.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
<!-- call-to-action -->
<section class="section" id="call-to-action" :style="{ backgroundImage: 'url(' + callToActionImage + ')' }">
  <div class="overlay"></div> <!-- The overlay element -->
  <div class="container">
    <div class="cta-content">
      <h2>Don’t <em>think</em>, begin <em>today</em>!</h2>
      <p>Every moment you hesitate is an opportunity missed. Begin your fitness transformation now and take control of your future. 
        The path to a healthier, stronger, and more confident you starts with a single step. Let's make it happen together!</p>
    </div>
  </div>
</section>


    <!-- Classes Section -->
    <section class="classes-section py-5 bg-light">
      <div class="container">
        <div class="text-center mb-5">
          <span class="section-subtitle">Our Classes</span>
          <h2 class="section-title">What We Can Offer</h2>
        </div>
        <div class="row">
          <div
            v-for="(classItem, index) in classes"
            :key="index"
            class="col-lg-3 col-md-4 mb-3">
            <div class="class-item">
              <img :src="classItem.image" class="img-fluid rounded" alt="Class Image">
              <div class="class-text mt-3">
                <span>{{ classItem.category }}</span>
                <h5>{{ classItem.title }}</h5>
                <!-- <a href="#" class="btn btn-outline-warning mt-2">Learn More</a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Pricing Section -->
    <!-- <section class="pricing-section py-5">
      <div class="container">
        <div class="text-center mb-5">
          <span class="section-subtitle">Our Plans</span>
          <h2 class="section-title">Choose Your Pricing Plan</h2>
        </div>
        <div class="row justify-content-center">
          <div
            v-for="(plan, index) in pricingPlans"
            :key="index"
            class="col-lg-4 col-md-6 mb-4">
            <div class="pricing-item shake-animation">
              <h3>{{ plan.name }}</h3>
              <div class="price">
                <h2>{{ plan.price }}</h2>
                <span>{{ plan.subtitle }}</span>
              </div>
              <ul class="pricing-features">
                <li v-for="(feature, index) in plan.features" :key="index">{{ feature }}</li>
              </ul>
              <a href="#" class="btn btn-warning mt-3">Enroll Now</a>
            </div>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      heroSlides: [
  {
    image: "/images/insidegymcarousel.jpg", // Ensure the correct path is set for images
    subtitle: "Build Strength, Transform Your Body",
    strongText: "Powerful",
    title: "Push Your Limits Every Day",
  },
  {
    image: "/images/insidegymcarousel1.jpg",
    subtitle: "Achieve Your Fitness Goals",
    strongText: "Resilient",
    title: "Join the Fit Revolution",
  },
  {
    image: "/images/insidegymcarousel2.jpg",
    subtitle: "Become the Best Version of Yourself",
    strongText: "Unstoppable",
    title: "Fitness. Dedication. Results.",
  },
],
      features: [
        {
          icon: "dumbbell",
          title: "Modern Equipment",
          description: "State-of-the-art facilities to help you train better.",
        },
        {
          icon: "apple-alt",
          title: "Healthy Nutrition Plan",
          description: "Custom diet plans tailored for your fitness goals.",
        },
        {
          icon: "user-tie",
          title: "Professional Trainers",
          description: "Certified experts to guide you every step of the way.",
        },
        {
          icon: "heartbeat",
          title: "Personalized Programs",
          description: "Programs designed just for you.",
        },
      ],
      classes: [
  {
    image: "/images/weightlifting.jpg",
    category: "Strength",
    title: "Power Lifting",
  },
  {
    image: "/images/indoorcycling.jpg",
    category: "Cardio",
    title: "Cardio Training",
  },
  {
    image: "/images/kettlebell.jpg",
    category: "Strength",
    title: "Kettlebell Power",
  },
  {
    image: "/images/weightloss.jpg",  // Ensure the image path is correct
    category: "Fitness",
    title: "Weight Loss",
  },
  {
    image: "/images/weightgain.jpg",  // Ensure the image path is correct
    category: "Fitness",
    title: "Weight Gain",
  },
  {
    image: "/images/bodybuilding.jpg",  // Ensure the image path is correct
    category: "Strength",
    title: "Bodybuilding",
  },
  {
    image: "/images/functionaltraining.jpg",  // Ensure the image path is correct
    category: "Functional Training",
    title: "Functional Training",
  },
  {
    image: "/images/groupclass.jpg",  // Ensure the image path is correct
    category: "Group",
    title: "Group Class",
  },
  {
    image: "/images/coremuscles.jpg",  // Ensure the image path is correct
    category: "Strength",
    title: "Core Muscles",
  },
  {
    image: "/images/westerndance.jpg",  // Ensure the image path is correct
    category: "Dance",
    title: "Western Dance",
  },
  {
    image: "/images/zumba.jpg",  // Ensure the image path is correct
    category: "Dance",
    title: "Zumba",
  },
  {
    image: "/images/kidsdance.jpg",  // Ensure the image path is correct
    category: "Kids",
    title: "Kids Dance",
  },
  {
    image: "/images/classicaldance.jpg",  // Ensure the image path is correct
    category: "Dance",
    title: "Classical Dance",
  },
  {
    image: "/images/endurancetraining.jpg",  // Ensure the image path is correct
    category: "Strength",
    title: "Endurance Training",
  },
  {
    image: "/images/dietplan.jpg",  // Ensure the image path is correct
    category: "Nutrition",
    title: "Diet Plan",
  },
  {
    image: "/images/certifiedtrainer.jpg",  // Ensure the image path is correct
    category: "Trainers",
    title: "Certified Trainers",
  },
],

      pricingPlans: [
        {
          name: "3 Months Unlimited",
          price: "₹1200",
          subtitle: "PER 3 MONTHS",
          features: ["Free Riding", "Unlimited Equipment", "Personal Trainer"],
        },
        {
          name: "6 Months Unlimited",
          price: "₹2100",
          subtitle: "PER 6 MONTHS",
          features: ["Free Riding", "Unlimited Equipment", "Weight Loss Classes"],
        },
        {
          name: "12 Months Unlimited",
          price: "₹3600",
          subtitle: "PER 12 MONTHS",
          features: ["Unlimited Equipment", "Personal Trainer", "Free Consultation"],
        },
      ],
      callToActionImage: "/images/insidegymcarousel5.jpg", // Correct path to your background image
    };
  },
};
</script>

<style scoped>
/* Common Theme Colors */
:root {
  --primary-color: #ffc107;
  --bg-dark: #2b2a2a;
  --shadow-color: rgba(231, 231, 231, 0.2);
  --text-color: #fff;
}

/* Hero Section */
.hero-slide {
  height: 100vh;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-color);
  text-align: left;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-color);
}
/* Hero Text Styling */
.hi-text span {
  display: block;
  font-size: 1.2rem;
  margin-bottom: 10px;
  text-transform: uppercase;
  color: white;
  font-family: 'Open Sans', sans-serif;
  letter-spacing: 1px; /* Add space between letters */
}

.hi-text h1 {
  font-size: 1.5rem; /* Larger font size for the title */
  font-weight: 500; /* Bold weight */
  color: white; /* White text color */
  font-family: 'Roboto', sans-serif; /* Set the font family */
  text-shadow: 
    2px 2px 4px rgba(0, 0, 0, 0.6),  /* Black shadow */
    -2px -2px 4px rgba(0, 0, 0, 0.6);  /* Black shadow */
  letter-spacing: 2px; /* Space between letters */
  line-height: 1.3; /* Adjust line height to add space between lines */
  transform: translateY(-10px); /* Slight upward shift for dynamic feel */
  animation: shakeText 1s ease-in-out infinite; /* Add animation */
}

/* Strong Text inside h1 */
.hi-text h1 strong {
  color: var(--primary-color); /* Primary color for strong text */
  font-family: 'Open Sans', sans-serif; /* A different font for emphasis */
  font-weight: 600; /* Slightly lighter weight for strong text */
}

/* Animation for shaking text */
@keyframes shakeText {
  0% {
    transform: translateY(-10px);
  }
  25% {
    transform: translateY(10px);
  }
  50% {
    transform: translateY(-10px);
  }
  75% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(-10px);
  }
}
/* Features Section */
.feature-item i {
  font-size: 3rem;
  color: var(--primary-color);
}

/* Classes Section */
.class-item img {
  border-radius: 10px;
  transition: transform 0.3s ease;
  box-shadow: 0px 4px 6px var(--shadow-color);
}

.class-item:hover img {
  transform: scale(1.05);
}
/* call-to-action */
/* Call-to-Action Section */
#call-to-action {
  position: relative;
  text-align: center;
  color: white;
  width: 100%;
  height: 250px; /* Adjust the height for the stripe */
  background-color: #333; /* Optional solid background color */
  background-size: cover;
  background-position: center center;
  overflow: hidden; /* Prevent overflow issues */
}

#call-to-action .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Semi-transparent overlay */
  z-index: 1;
}

.cta-content {
  position: relative;
  z-index: 2; /* Ensure it's above the overlay */
  text-align: center;
  color: #ffc107; /* Bright, contrasting font color */
  font-family: 'Roboto', sans-serif;
  padding: 20px;
}

.cta-content h2 {
 
  font-size: 2rem; /* Large headline */
  font-weight: 600;
  color: #ffc107; /* Primary color */
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7); /* Subtle shadow for contrast */
  margin-bottom: 10px;
  text-transform: uppercase;
  
}

.cta-content em {
  font-style: italic;
  color: #ffffff; /* Highlighted text color for emphasis */
}

.cta-content p {
  font-size: 1rem; /* Subtext size */
  margin-top: 10px;
  color: #fff; /* White color for paragraph text */
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6); /* Subtle shadow */
  line-height: 1.6; /* Comfortable line spacing */
}


/* Pricing Section */
.pricing-item {
  background: linear-gradient(135deg, #2b2a2a, #ffc107);
  color: var(--text-color);
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 4px 6px var(--shadow-color);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: slow-shake 2s infinite ease-in-out; /* Slow shaking animation */
}

.pricing-item:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.3);
}

.pricing-item .price h2 {
  font-size: 2.5rem;
  color: var(--primary-color);
}

.pricing-features {
  list-style: none;
  padding: 0;
}

.pricing-features li {
  margin: 10px 0;
}


/* Shaking Animation */
@keyframes slow-shake {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-3px);
  }
  50% {
    transform: translateX(3px);
  }
  75% {
    transform: translateX(-3px);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
